import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET, POST, PUT, DELETE } from '../../services/api';

// Add Home Category
export const addHomeCategory = createAsyncThunk(
  'homeCategory/add',
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST('/admin/home-category', data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to add category');
    }
  }
);

// List Home Categories
export const listHomeCategory = createAsyncThunk(
  'homeCategory/list',
  async (params={}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/home-category', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch categories');
    }
  }
);

// View Home Category
export const viewHomeCategory = createAsyncThunk(
  'homeCategory/view',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await GET(`/admin/home-category/view`, { h_category_id: categoryId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'An error occurred');
    }
  }
);

// Update Home Category
export const updateHomeCategory = createAsyncThunk(
  'homeCategory/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PUT(`/admin/home-category?h_category_id=${id}`, data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to update category');
    }
  }
);

// Delete Home Category
export const deleteHomeCategory = createAsyncThunk(
  'homeCategory/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(`/admin/home-category`, { h_category_id: id });
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to delete category');
    }
  }
);

const HomeCategorySlice = createSlice({
  name: 'homeCategory',
  initialState: {
    addCategory: [],
    addCategoryLoading: false,
    addCategoryError: null,
    listCategory: [],
    listCategoryCount: "",
    listCategoryLoading: false,
    listCategoryError: null,
    viewCategory: [],
    viewCategoryLoading: false,
    viewCategoryError: null,
    updateCategory: [],
    updateCategoryLoading: false,
    updateCategoryError: null,
    deleteCategory: [],
    deleteCategoryLoading: false,
    deleteCategoryError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(viewHomeCategory.pending, (state) => {
        state.viewCategoryLoading = true;
        state.viewCategoryError = null;
      })
      .addCase(viewHomeCategory.fulfilled, (state, action) => {
        state.viewCategoryLoading = false;
        state.viewCategory = action.payload.result;
      })
      .addCase(viewHomeCategory.rejected, (state, action) => {
        state.viewCategoryLoading = false;
        state.viewCategoryError = action.error.message;
      })
      .addCase(addHomeCategory.pending, (state) => {
        state.addCategoryLoading = true;
        state.addCategoryError = null;
      })
      .addCase(addHomeCategory.fulfilled, (state, action) => {
        state.addCategoryLoading = false;
        state.addCategory = action.payload;
      })
      .addCase(addHomeCategory.rejected, (state, action) => {
        state.addCategoryLoading = false;
        state.addCategoryError = action.error.message;
      })
      .addCase(listHomeCategory.pending, (state) => {
        state.listCategoryLoading = true;
        state.listCategoryError = null;
      })
      .addCase(listHomeCategory.fulfilled, (state, action) => {
        state.listCategoryLoading = false;
        state.listCategory = action.payload;
        state.listCategory = action.payload?.result?.rows;
        state.listCategoryCount = action.payload?.result?.count;
      })
      .addCase(listHomeCategory.rejected, (state, action) => {
        state.listCategoryLoading = false;
        state.listCategoryError = action.error.message;
      })
      .addCase(updateHomeCategory.pending, (state) => {
        state.updateCategoryLoading = true;
        state.updateCategoryError = null;
      })
      .addCase(updateHomeCategory.fulfilled, (state, action) => {
        state.updateCategoryLoading = false;
        state.updateCategory = action.payload;
      })
      .addCase(updateHomeCategory.rejected, (state, action) => {
        state.updateCategoryLoading = false;
        state.updateCategoryError = action.error.message;
      })
      .addCase(deleteHomeCategory.pending, (state) => {
        state.deleteCategoryLoading = true;
        state.deleteCategoryError = null;
      })
      .addCase(deleteHomeCategory.fulfilled, (state, action) => {
        state.deleteCategoryLoading = false;
        state.deleteCategory = action.payload;
      })
      .addCase(deleteHomeCategory.rejected, (state, action) => {
        state.deleteCategoryLoading = false;
        state.deleteCategoryError = action.error.message;
      });
  },
});

export default HomeCategorySlice.reducer;